import { Component, Input, OnInit } from '@angular/core';
import { SocialLink } from 'src/app/model/shared/social-link';
import { ContentfulService } from 'src/app/service/contentful.service';

@Component({
  selector: 'app-social-links',
  templateUrl: './social-links.component.html',
  styleUrls: ['./social-links.component.scss']
})
export class SocialLinksComponent implements OnInit {
  @Input() menuName = 'Footer Menu#SOCIAL';

  socialLinks: SocialLink = {} as SocialLink;

  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    let query = { 'fields.name': this.menuName };
    this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
      this.socialLinks.tabs = menuItems[0]?.fields.jsonData;
    });
  }
}
